var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4 20.3409C34.4 19.2773 34.3045 18.2546 34.1273 17.2728H20V23.075H28.0727C27.725 24.95 26.6682 26.5387 25.0795 27.6023V31.3659H29.9273C32.7636 28.7546 34.4 24.9091 34.4 20.3409Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35C24.05 35 27.4455 33.6568 29.9273 31.3659L25.0795 27.6022C23.7364 28.5022 22.0182 29.0341 20 29.0341C16.0932 29.0341 12.7864 26.3954 11.6068 22.85H6.59546V26.7363C9.06364 31.6386 14.1364 35 20 35Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6068 22.85C11.3068 21.95 11.1364 20.9887 11.1364 20C11.1364 19.0114 11.3068 18.05 11.6068 17.15V13.2637H6.59545C5.57955 15.2887 5 17.5796 5 20C5 22.4205 5.57955 24.7114 6.59545 26.7364L11.6068 22.85Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.9659C22.2023 10.9659 24.1796 11.7227 25.7341 13.2091L30.0364 8.90682C27.4386 6.48636 24.0432 5 20 5C14.1364 5 9.06364 8.36136 6.59546 13.2636L11.6068 17.15C12.7864 13.6045 16.0932 10.9659 20 10.9659Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.2ca1f430bbb110c66b5675905545146b.svg";
export { ForwardRef as ReactComponent };